// Widget Scripts
import customTicketButton from './js/widgets/customTicketButton.js';

// Custom Theme Scripts
import './js/localjs.js';

// Initialize Homepage Widgets
$(document).ready(function () {
  customTicketButton();
});
